<template>
  <div class="box" @click="back">
    <img class="logo" src="@/assets/img/icon-backcenter.png" alt="">
    <div class="title">
      <div>{{ backStr.cn || '返回赛事中心' }}</div>
      <div> {{ backStr.en || 'BACK TO COMPETITION CENTER' }} </div>
    </div>
  </div>
</template>


<script>

export default {
  props: {
    backStr: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>


<style lang="scss" scoped>
.box {
  width: 216px;
  height: 70px;
  opacity: 1;
  /* 自动布局 */
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  gap: 10px;
  align-self: stretch;

  background: linear-gradient(180deg, #E3F1FF 15%, #E5F1FF 98%);

  box-sizing: border-box;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.8) 40%, rgba(255, 255, 255, 0) 100%) 1 1 0 1;

  backdrop-filter: blur(10px);
  cursor: pointer;


  .title {
    >div:first-child {
      height: 24px;
      opacity: 1;

      font-family: Microsoft YaHei;
      font-size: 20px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      color: #212B5C;
      margin-bottom: 10px;
    }

    >div:last-child {

      font-family: D-DIN-PRO-400-Regular;
      font-size: 16px;
      font-weight: bold;
      line-height: 16px;
      font-variation-settings: "opsz" auto;
      color: #727EB6;
      white-space: nowrap;
      transform: scaleX(0.7);
      transform-origin: left;
    }
  }

}
</style>